<template lang="pug">
  .component-parkinglot-action-buttons
    ul.dropdown.menu(data-dropdown-menu='', v-f="", v-if="entity")
      li
        a(href='#Item-1') Action
        ul.menu
          li
            a(@click="edit") Edit
          li
            ModalReveal
              button.button(slot="trigger" ) Configuration
              textarea(rows="10", v-model="entity.config")

              ActionButton(:action="save") Save
    .dropdown-buttons(v-else-if="!entity && parkingLot")
      .small.button.alert(@click="remove") Delete
</template>

<script>
  import MaggieHelper from '../../../../maggieHelper'
  import ParkingLotEdit from '../../../backoffice/smartedits/ParkingLotEdit'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import ModalReveal from "../../foundation/ModalReveal.vue";
  import ActionButton from "../ActionButton.vue";
  import {EventBus} from "../../../../eventBus";

  export default {
    name: 'ParkingLotActionButtons',
    components: {ActionButton, ModalReveal},
    data() {
      return {
        entity: {config:null},
      }
    },
    created() {
      this.entity.config = JSON.stringify({}, null, 2)

      if (this.parkingLot === null) {
        KeplerBackofficeSdk.parkingLots.select(this.$route.params.id).get((item) => {
          this.entity = item
          this.entity.config = JSON.stringify(this.entity.config, null, 2)
        })
      }
    },
    methods: {
      save(){
        const body = {...this.entity}
        body.slots = this.entity.parking_slots.length
        body.latitude = this.entity.position.latitude
        body.longitude = this.entity.position.longitude
        body.config = JSON.parse(this.entity.config)
        return KeplerBackofficeSdk.parkingLots.select(this.$route.params.id).update(body, (data) => {
          MaggieHelper.notification('update-esit', 'Parking lot updated')
          EventBus.$emit('close-modal')
        })
      },
      remove() {
        this.$confirm('Are you sure?', 'Will be tried a hard delete on all the parking slots and vehicle slots connected', () => {
          KeplerBackofficeSdk.parkingLots.select(this.parkingLot).remove(() => {
            MaggieHelper.notification('Deleted', 'Parking lot and on all the parking slots and vehicle slots connected have been deleted')
          })
        })
      },
      edit() {
        MaggieHelper.openRightPanel({
          component: ParkingLotEdit, props: {
            item: this.entity
          }
        })
      },
    },
    props: {
      parkingLot: {
        default: null
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ParkingLotActionButtons.vue?8d3dc38e